module.exports = __webpack_public_path__ + "img/vi.ec18ca3b.png";